/* Word-level text reveal.
   Wraps each word of a heading in a masked span so words can rise into view
   individually. Purely additive: if this never runs, the heading renders as
   normal text. */
(function () {
  'use strict';

  var TARGETS = '.ts-story__heading';

  function splitWords(el) {
    if (el.dataset.tsSplit === 'done') return;
    var text = el.textContent.replace(/\s+/g, ' ').trim();
    if (!text) return;

    // Preserve the readable string for assistive tech, then hide the
    // decorative spans from the accessibility tree.
    el.setAttribute('aria-label', text);

    var words = text.split(' ');
    var html = words.map(function (w, i) {
      return '<span class="ts-w" aria-hidden="true">' +
             '<span class="ts-w__i" style="--ts-w-d:' + (i * 70) + 'ms">' +
             w.replace(/&/g, '&amp;').replace(/</g, '&lt;') +
             '</span></span>';
    }).join(' ');

    el.innerHTML = html;
    el.dataset.tsSplit = 'done';
  }

  function init() {
    document.querySelectorAll(TARGETS).forEach(splitWords);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
  document.addEventListener('shopify:section:load', init);
})();
